import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import PerformanceInsightsTemplate from './performance-insights.pug';

export class PerformanceInsightsColumn extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'PerformanceInsights',
      property: 'PerformanceInsights',
      title: i18n.getString('ColumnName_PerformanceInsights'),
      sortable: 'PerformanceInsights',
      bodyClasses: ['grid-column-PerformanceInsightsColumn'],
      type: 'number',
      helpId: 'Pop_BA_Recommendations_OptScoreAcct', // TODO: Update helpId
    });
    this.i18n = i18n;
  }

  pickProperty(item) {
    // TODO: integrate API response
    let performanceInsights = {
      issue: 0,
      recommendation: 0,
    };
    if (item.Name === 'OPT-Test-Campaign-00') {
      performanceInsights = {
        issue: 2,
        recommendation: 1,
      };
    } else if (item.Name === 'OPT-Test-Campaign-01') {
      performanceInsights = {
        issue: 0,
        recommendation: 1,
      };
    }
    return performanceInsights;
  }

  template({ value }) {
    const { i18n } = this;
    const { issue, recommendation } = value;
    let status = '-';
    if (issue > 0) {
      status = issue === 1 ? i18n.getString('Issue_Singular', { n: issue }) : i18n.getString('Issues', { n: issue });
    } else if (recommendation > 0) {
      status = recommendation === 1 ? i18n.getString('Recommendation_Singular', { n: recommendation }) : i18n.getString('Recommendations', { n: recommendation });
    }
    return PerformanceInsightsTemplate({ status, issue, recommendation });
  }
}
